/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
const safeRemoveChild=(e,o)=>{const d=e instanceof Node,n=o instanceof Node&&o.parentNode===e;return d&&n?e.removeChild(o):void 0};export default safeRemoveChild;